module.exports = __webpack_public_path__ + "static/media/desarrollo9.c40eaa01.png";